import React from "react";

export default function EditorHeader({
	studentName,
	trainingName,
	isTemplate,
	hasTraining = false,
	hasActions = true,
	headerExtra = null,
	onHistorique,
	onDupliquer,
	onPlanifier,
}) {
	return (
		<header className="editor-header">
			<div className="editor-header-crumb">
				{studentName && (
					<>
						<span className="editor-header-crumb-segment">{studentName}</span>
						<span className="editor-header-crumb-sep">/</span>
					</>
				)}
				<span className={`editor-header-crumb-current ${!trainingName ? "muted" : ""}`}>
					{trainingName || "Aucune séance ouverte"}
				</span>
				{isTemplate && <span className="editor-header-badge">TEMPLATE</span>}
			</div>

			{hasTraining && hasActions && (
				<div className="editor-header-actions">
					<button className="editor-header-btn" onClick={onHistorique} title="Historique" disabled={!onHistorique}>
						Historique
					</button>
					<button className="editor-header-btn" onClick={onDupliquer}>
						Dupliquer
					</button>
					<button className="editor-header-btn editor-header-btn-primary" onClick={onPlanifier}>
						Planifier
					</button>
				</div>
			)}

			{hasTraining && !hasActions && headerExtra && (
				<div className="editor-header-actions">{headerExtra}</div>
			)}
		</header>
	);
}
